<template>
  <div>
    <div class="position-relative">
      <div class="workspace-title">
        <b-row>
          <b-col lg="12" xl="9">
            <b-row>
              <b-col>
                Inbox
              </b-col>
              <b-col cols="auto">
                <b-button variant="primary" class="pl-4 pr-4" @click.prevent="$refs.sendmsg.show()">
                  New message
                </b-button>
                <b-modal ref="sendmsg" hide-footer size="lg" title="New message">
                  <send-message @submitted="onMsgSubmitted" />
                </b-modal>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </div>
    <b-row>
      <b-col tag="main" lg="12" xl="9" order="2" order-xl="1" class="mb-4">
        <messages
          :type="type"
          :loading="loading"
          :messages="messages"
          @change="onChangeType"
          @seen="onSeenMessage"
        />
      </b-col>
      <b-col lg="12" xl="3" order="1" order-xl="2">
        <b-row>
          <b-col tag="aside" lg="6" xl="12" class="mb-4">
            <ask-recognition class="shadow h-100" />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SendMessage from './SendMessage.vue'
import Messages from '@/components/Messages'
import { AskRecognition } from './Aside'

export default {
  name: 'Inbox',

  data() {
    return {
      type: 'received'
    }
  },

  computed: {
    ...mapGetters([
      'receivedMessages',
      'isReceivedLoading',
      'sentMessages',
      'isSentLoading'
    ]),

    messages() {
      return this.type === 'received' ? this.receivedMessages : this.sentMessages
    },

    loading() {
      return this.type === 'received' ? this.isReceivedLoading : this.isSentLoading
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      switch (this.type) {
        case 'received':
          this.$store.dispatch('fetchReceivedMessages')
          break
        case 'sent':
          this.$store.dispatch('fetchSentMessages')
          break
      }
    },

    onChangeType(type) {
      this.type = type
      this.load()
    },

    onSeenMessage(message) {
      this.$store.dispatch('seenMessage', message.id)
    },

    onMsgSubmitted() {
      this.$refs.sendmsg.hide()
    }
  },

  components: {
    Messages,
    SendMessage,
    AskRecognition
  }
}
</script>
